import styled from "styled-components";
import { BASIC_BROWN, BASIC_GRAY_BACKGROUND } from "../../../constants/colors";

type Props = {
  title: string;
  iconUrl: string;
  iconBackgroundColor?: string;
  children: React.ReactNode;
};

export const HomeItem: React.FC<Props> = ({
  title,
  iconUrl,
  iconBackgroundColor = "transparent",
  children,
}) => {
  return (
    <Container>
      <Title>
        <Icon
          data-testid="home-item-icon"
          style={{ backgroundImage: `url('${iconUrl}')` }}
          $backgroundColor={iconBackgroundColor}
        ></Icon>
        <span>{title}</span>
      </Title>

      <ChildrenContainer>{children}</ChildrenContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 10px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding: 12px 0;
  line-height: 1;
  font-weight: 600;
  background-color: ${BASIC_BROWN};
  color: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Icon = styled.div<{ $backgroundColor: string }>`
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  width: 17px;
  height: 18px;
  margin: 0 5px;
`;

const ChildrenContainer = styled.div`
  background-color: ${BASIC_GRAY_BACKGROUND};
  padding: 27px 18px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
